import { useTheme } from '@mui/material'

interface NoteTextProps {
  title?: string
  text?: string
}

export function TextWithLinks(props: NoteTextProps) {
  const theme = useTheme()

  if (!props.text) return <></>
  const textWithLinks = props.text
  const parts = textWithLinks.includes('http')
    ? textWithLinks.split(/(https?:\/\/\S+)/)
    : [textWithLinks]

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation()
    event.preventDefault()
    const url = event.currentTarget.href
    window.open(url, '_blank', 'noopener,noreferrer')
  }
  return (
    <span
      style={{
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
        wordBreak: 'break-word'
      }}
    >
      {parts.map((part, index) => {
        if (part.match(/https?:\/\/\S+/)) {
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleClick}
              style={{
                color: theme.palette.button.text.link as string,
                overflowWrap: 'anywhere',
                wordBreak: 'break-word'
              }}
            >
              {props.title ?? part}
            </a>
          )
        }
        return part
      })}
    </span>
  )
}
